{
  "name": "pulse-grid",
  "doc": "A zoom-out from a centre set low in the frame with a slight stretch: the history rises and widens like a floor grid seen from above. The MIRROR wave draws the grid's rungs.",
  "cx": 0.5,
  "cy": 0.32,
  "zoom": 0.982,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": -0.002,
  "sx": 1.006,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.952,
  "invert": 0,
  "hueShift": 0.003,
  "darkenCenter": 0.0,
  "wave": "MIRROR",
  "waveColor": 2,
  "shapes": 0,
  "energy": [
    0.5,
    0.95
  ]
}